export const configure = {
	StorageKey: {
		Vendor: "vendor",
		Token: "vendor-token",
		CurrentStore: "current-store",
	}
}